import React from "react"
import { usePermission } from "hooks/usePermission"
import { ModelsAttributesValuesBinding } from "./index"
import PageNotSupported from "../../../components/PageNotSupported"

export const ModelsAttributesValuesBindingRoute: React.FC = () => {
    const { credentials } = usePermission()
    console.log(credentials)

    const hasDeprecatedAccess =
        credentials.includes("series.deprecated_access") ||
        credentials.includes("model.deprecated_access")

    return hasDeprecatedAccess ? (
        <ModelsAttributesValuesBinding />
    ) : (
        <PageNotSupported />
    )
}